import IconEmphasized from "ds/components/IconEmphasized";
import { LogoSlackColored } from "components/icons/generated";

import { CellComponentProps } from "../types";

type UserIntegrationsListItemTypeCellProps = CellComponentProps;

const UserIntegrationsListItemTypeCell = ({
  integration,
}: UserIntegrationsListItemTypeCellProps) => {
  if (integration.type === "Slack") {
    return <IconEmphasized icon={LogoSlackColored} />;
  }

  return null;
};

export default UserIntegrationsListItemTypeCell;
